var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _c("div", { staticClass: "ai-header-banner" }, [
        _c("div", { staticClass: "banner-overlay" }),
        _c("div", { staticClass: "banner-content" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "banner-actions flex gap-2" },
            [
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn green-btn",
                  attrs: {
                    type: "success",
                    icon: "el-icon-plus",
                    disabled: _vm.dataSearch.delActive === false,
                  },
                  on: { click: _vm.handleCreateActionCommand },
                },
                [_vm._v("\n          Thêm hoạt động mới\n        ")]
              ),
              _c(
                "el-dropdown",
                {
                  staticClass: "modern-dropdown-wrapper",
                  attrs: { disabled: _vm.dataSearch.delActive === false },
                  on: { command: _vm.handleCommand },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "gradient-btn purple-btn",
                      attrs: {
                        type: "warning",
                        disabled: _vm.dataSearch.delActive === false,
                      },
                    },
                    [
                      _vm._v("\n            Tác vụ gộp "),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]
                  ),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "modern-dropdown-menu",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _vm.showAction
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: "activeAction",
                                icon: "el-icon-circle-check",
                              },
                            },
                            [_vm._v("Kích hoạt")]
                          )
                        : _vm._e(),
                      _vm.showNoAction
                        ? _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: "no-activeAction",
                                icon: "el-icon-circle-close",
                              },
                            },
                            [_vm._v("Hủy kích hoạt")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "ai-stats-grid" }, [
        _c("div", { staticClass: "stat-card blue" }, [
          _vm._m(1),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [_vm._v("Tổng hoạt động")]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.totalRecords)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card green" }, [
          _vm._m(2),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Đang chạy (trang này)"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.stats.activeCount)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "stat-card purple" }, [
          _vm._m(3),
          _c("div", { staticClass: "stat-info" }, [
            _c("p", { staticClass: "stat-label" }, [
              _vm._v("Đã lưu trữ / Xóa"),
            ]),
            _c("h3", { staticClass: "stat-value" }, [
              _vm._v(_vm._s(_vm.dataSearch.delActive ? "Chưa xóa" : "Đã xóa")),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "glass-card mb-4" },
        [
          _c(
            "el-form",
            {
              staticClass: "modern-filter-form",
              attrs: { inline: true, model: _vm.dataSearch },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái hoạt động" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: {
                        clearable: "",
                        placeholder: "Tất cả trạng thái",
                      },
                      on: { change: _vm.findAllData },
                      model: {
                        value: _vm.dataSearch.statusAction,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "statusAction", $$v)
                        },
                        expression: "dataSearch.statusAction",
                      },
                    },
                    _vm._l(_vm.listStatusAction, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.key, label: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Trạng thái lưu trữ" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "modern-select",
                      attrs: { placeholder: "Loại lưu trữ" },
                      on: { change: _vm.findAllData },
                      model: {
                        value: _vm.dataSearch.delActive,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "delActive", $$v)
                        },
                        expression: "dataSearch.delActive",
                      },
                    },
                    _vm._l(_vm.listDelActive, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item.key, label: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Tìm tên hoạt động" } },
                [
                  _c("el-input", {
                    staticClass: "modern-input",
                    attrs: {
                      clearable: "",
                      placeholder: "Nhập tên hoạt động...",
                      "prefix-icon": "el-icon-search",
                    },
                    on: { clear: _vm.findAllData },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.findAllData.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.dataSearch.nameAction,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataSearch, "nameAction", $$v)
                      },
                      expression: "dataSearch.nameAction",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.findAllData },
                    },
                    [_vm._v("Lọc dữ liệu")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "glass-card table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingData,
                  expression: "loadingData",
                },
              ],
              staticClass: "modern-table",
              attrs: {
                data: _vm.listHistoryActionAdmin,
                "element-loading-text": "Đang tải lịch sử hoạt động S3...",
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(255,255,255,0.7)",
                border: "",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  index: _vm.calculateStt,
                  label: "STT",
                  width: "55",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nameAction",
                  label: "Tên hoạt động",
                  "min-width": "220",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "click-in-row-btn",
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.detailAction(row)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-folder",
                              staticStyle: { "margin-right": "4px" },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(row.nameAction) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "codeAction",
                  label: "Mã hoạt động",
                  "min-width": "160",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("code", { staticClass: "code-badge" }, [
                          _vm._v(_vm._s(row.codeAction)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Trạng thái", width: "160", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "status-badge",
                            class: row.statusAction ? "online" : "offline",
                          },
                          [
                            _c("span", { staticClass: "dot" }),
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  row.statusAction
                                    ? "Đang hoạt động"
                                    : "Ngừng hoạt động"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "typeAction",
                  label: "Loại tác vụ",
                  "min-width": "140",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "info",
                              size: "medium",
                              effect: "plain",
                            },
                          },
                          [_vm._v(_vm._s(row.typeAction))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Tác vụ",
                  width: "280",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-time",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(row)
                              },
                            },
                          },
                          [_vm._v("\n            Lịch sử\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              size: "mini",
                              icon: "el-icon-edit",
                              disabled: row.delActive === false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                          },
                          [_vm._v("Sửa\n          ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              icon: "el-icon-delete",
                              disabled:
                                row.statusAction === true ||
                                row.delActive === false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(row)
                              },
                            },
                          },
                          [_vm._v("Xóa\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper mt-3 flex justify-center" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.dataSearch.page,
                  "page-sizes": _vm.listSizePage,
                  "page-size": _vm.dataSearch.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalRecords,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentPageChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.dataSearch, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.dataSearch, "page", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("CreateHistoryActionDialog", {
        attrs: {
          listCodeAction: _vm.listCodeAction,
          isCreateHistoryAction: _vm.isCreateHistoryAction,
        },
        on: { close: _vm.handleCloseCreateHistoryActionDialog },
      }),
      _c("UpdateHistoryActionDialog", {
        attrs: {
          idHistory: _vm.idHistory,
          checkUpdate: _vm.checkUpdate,
          isUpdateHistoryAction: _vm.isUpdateHistoryAction,
        },
        on: { close: _vm.handleCloseUpdateHistoryActionDialog },
      }),
      _c("DetailHistoryActionDialog", {
        attrs: {
          isDetailHistoryAction: _vm.isDetailHistoryAction,
          idHistory: _vm.idHistory,
          codeAction: _vm.codeAction,
        },
        on: { close: _vm.handleDetailHistoryActionDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "banner-left" }, [
      _c("div", { staticClass: "ai-icon-pulse" }, [
        _c("i", { staticClass: "el-icon-files" }),
      ]),
      _c("div", [
        _c("h1", { staticClass: "banner-title" }, [
          _vm._v("LỊCH SỬ HOẠT ĐỘNG CLOUD (S3)"),
        ]),
        _c("p", { staticClass: "banner-subtitle" }, [
          _vm._v(
            "Giám sát và kiểm tra lịch sử ghi nhật ký hoạt động đồng bộ tệp tin, hình ảnh lên nền tảng Amazon S3."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-notebook-1" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-circle-check" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon" }, [
      _c("i", { staticClass: "el-icon-folder-delete" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }